import ModalCallbackFindCheaperFormPresenter from "../components/modal-callback-find-cheaper-form/presenter/modal-callback-find-cheaper-form.js";

const triggers = document.querySelectorAll(`.button_category-insertion_banner_with_form, .button_find-cheaper`);

Array.from(triggers)
  .forEach((trigger) => {
    const presenter = new ModalCallbackFindCheaperFormPresenter(trigger);
    presenter.init();
  });
